import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../../../css/OfferMediaCarousel.css";

export default function OfferMediaCarousel({ media = [] }) {
	if (!media.length) return null;

	return (
		<div className="offer-media-container">
			<h5 className="offer-media-title">Related photos & videos</h5>
			<Swiper
				effect={"cards"}
				grabCursor={true}
				modules={[EffectCards]}
				className="mySwiper"
			>
				{media.map((item, index) => (
					<SwiperSlide key={index}>
						{item.type === "image" ? (
							<img
								src={item.url || item.preview}
								className="carousel-preview"
								alt=""
							/>
						) : (
							<video
								src={item.url || item.preview}
								className="carousel-preview"
								controls
							/>
						)}
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
}
